/**
 * Watch for iframe changes and re-inject styles when iframe is added
 */
export const watchForIframeChanges = (
	callback: () => void,
): ( () => void ) => {
	let observer: MutationObserver | null = null;

	const startWatching = () => {
		observer = new MutationObserver( ( mutations ) => {
			mutations.forEach( ( mutation ) => {
				mutation.addedNodes.forEach( ( node ) => {
					if ( node.nodeType === Node.ELEMENT_NODE ) {
						const element = node as Element;
						if (
							element.tagName === 'IFRAME' &&
							element.getAttribute( 'name' ) === 'editor-canvas'
						) {
							// Wait for iframe to be ready
							const iframe = element as HTMLIFrameElement;
							iframe.addEventListener( 'load', callback );
						}
					}
				} );
			} );
		} );

		observer.observe( document.body, {
			childList: true,
			subtree: true,
		} );
	};

	startWatching();

	return () => {
		observer?.disconnect();
	};
};
